<template>

    <form @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)" ref="form">

        <input type="hidden" name="stay-on-page" v-model="stayOnPage">

        <div>

            <div class="packages-list-heading mb-4">
                Przypisane pakiety
                <button type="button" class="btn btn-danger btn-sm pull-right" :disabled="selectedAssignedPackages.length === 0" @click="removeSelected">Usuń zaznaczone</button>
            </div>

            <div class="packages-list-wrapper" v-if="assignedPackages.length > 0">
                <div class="package-element" v-for="(package_, index) in assignedPackagesSorted">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" v-bind:id="'assigned-package-' + index" v-model="selectedAssignedPackages" :value="package_">
                        <label class="custom-control-label" v-bind:for="'assigned-package-' + index"></label>
                        <label class="checkbox-text" v-bind:for="'assigned-package-' + index">
                            <img v-if="package_.area.icon_url !== null" :src="package_.area.icon_url" class="area-icon" :title="'Obszar: ' + package_.area.display_name">
                            <div v-if="package_.area.icon_url === null" class="area-icon-placeholder" :title="'Obszar: ' + package_.area.display_name">?</div>
                            <div class="package-name">
                                {{ package_.display_name }}
                                <b-badge
                                        pill
                                        v-if="package_.pivot && package_.pivot.interval"
                                        :variant="getBadgeVariant(package_.pivot.valid_until)"
                                        v-b-tooltip.hover
                                        :title="getBadgeText(package_)">
                                    Na {{ package_.pivot.interval }} dni
                                    <template v-if="package_.pivot.valid_until">(do {{package_.pivot.valid_until}})</template>
                                </b-badge>
                                <span v-show="checkIfShowAlertBadge(package_)" class="text-warning" v-b-tooltip.hover v-b-tooltip.html :title="getAlertBadgeText(package_)"><i class="fa fa-warning" aria-hidden="true"></i></span>
                            </div>
                        </label>
                    </div>
                    <div class="translation-progress">
                        <span v-b-tooltip.hover :title="'Poziom przetłumaczenia pakietu na język urządzenia (' + machine.language.toUpperCase() + ')'">
                            Tłumaczenia: {{ package_.translation_progress && package_.translation_progress.length ? Math.round(package_.translation_progress[0].translated_percent) + '%' : 'brak' }}
                        </span>
                    </div>
                    <div class="package-action">
                        <div class="dropdown d-inline m-0" v-if="package_.pivot && package_.pivot.interval">
                            <a href="#" class="btn btn-primary btn-xs m-0" :id="'assign-package-' + index" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Wydłuż termin</a>
                            <div class="dropdown-menu dropdown-menu-right" :aria-labelledby="'assign-package-' + index">
                                <a class="dropdown-item" href="javascript:void(0)" @click="extend(package_, 7)">O 7 dni</a>
                                <a class="dropdown-item" href="javascript:void(0)" @click="extend(package_, 30)">O 30 dni</a>
                                <a class="dropdown-item" href="javascript:void(0)" @click="extend(package_, 60)">O 60 dni</a>
                                <a class="dropdown-item" href="javascript:void(0)" @click="extend(package_, 90)">O 90 dni</a>
                            </div>
                        </div>
                        <a href="javascript:void(0)" @click="remove(package_)" class="btn btn-danger btn-xs m-0">Usuń</a>
                    </div>
                </div>
            </div>

            <div class="packages-list-empty" v-if="assignedPackages.length === 0">Brak pakietów</div>

        </div>

        <div class="mt-5">

            <div class="packages-list-heading mb-4">
                Pakiety dostępne do przypisania
                <div class="dropdown d-inline m-0 pull-right">
                    <button class="btn btn-primary btn-sm" id="assign-selected-packages" :disabled="selectedNotAssignedPackages.length === 0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Przypisz zaznaczone</button>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="assign-selected-packages">
                        <a class="dropdown-item" href="javascript:void(0)" @click="assignSelected()">Na stałe</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="assignSelected(7)">Na 7 dni</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="assignSelected(30)">Na 30 dni</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="assignSelected(60)">Na 60 dni</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="assignSelected(90)">Na 90 dni</a>
                    </div>
                </div>
            </div>

            <div class="packages-list-wrapper mb-4" v-if="availablePackages.length > 0">
                <div class="package-element" v-for="(package_, index) in availablePackagesSorted">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" v-bind:id="'not-assigned-package-' + index" v-model="selectedNotAssignedPackages" :value="package_">
                        <label class="custom-control-label" v-bind:for="'not-assigned-package-' + index"></label>
                        <label class="checkbox-text" v-bind:for="'not-assigned-package-' + index">
                            <img v-if="package_.area.icon_url !== null" :src="package_.area.icon_url" class="area-icon" :title="'Obszar: ' + package_.area.display_name">
                            <div v-if="package_.area.icon_url === null" class="area-icon-placeholder" :title="'Obszar: ' + package_.area.display_name">?</div>
                            <div class="package-name">
                                {{ package_.display_name }}
                            </div>
                        </label>
                    </div>
                    <div class="translation-progress">
                        <span v-b-tooltip.hover :title="'Poziom przetłumaczenia pakietu na język urządzenia (' + machine.language.toUpperCase() + ')'">
                            Tłumaczenia: {{ package_.translation_progress && package_.translation_progress.length ? Math.round(package_.translation_progress[0].translated_percent) + '%' : 'brak' }}
                        </span>
                    </div>
                    <div class="package-action">
                        <div class="dropdown d-inline m-0">
                            <a href="#" class="btn btn-primary btn-xs m-0" :id="'assign-package-' + index" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Przypisz</a>
                            <div class="dropdown-menu dropdown-menu-right" :aria-labelledby="'assign-package-' + index">
                                <a class="dropdown-item" href="javascript:void(0)" @click="assign(package_)">Na stałe</a>
                                <a class="dropdown-item" href="javascript:void(0)" @click="assign(package_, 7)">Na 7 dni</a>
                                <a class="dropdown-item" href="javascript:void(0)" @click="assign(package_, 30)">Na 30 dni</a>
                                <a class="dropdown-item" href="javascript:void(0)" @click="assign(package_, 60)">Na 60 dni</a>
                                <a class="dropdown-item" href="javascript:void(0)" @click="assign(package_, 90)">Na 90 dni</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="packages-list-empty mb-4" v-if="availablePackages.length === 0">Brak pakietów</div>

        </div>

    </form>

</template>

<script>

    export default {

        name: 'MachinePackages',

        props: [
            'machineInput',
            'allPackages',
            'assignedPackagesInput'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                machine: null,
                availablePackages: [],
                assignedPackages: [],
                selectedAssignedPackages: [],
                selectedNotAssignedPackages: [],
                form: null,
                edited: false,
                stayOnPage: false
            }
        },

        computed: {
            availablePackagesSorted: function () {
                return _.orderBy(this.availablePackages, 'order')
            },
            assignedPackagesSorted: function () {
                return _.orderBy(this.assignedPackages, 'order')
            }
        },

        beforeMount() {

            this.machine = this.machineInput;
            this.availablePackages = this.allPackages;
            this.assignedPackages = this.assignedPackagesInput;
            this.assignedPackages.forEach(package_ => {
                this.availablePackages.splice(this.availablePackages.findIndex(item => item.id === package_.id), 1);
            });
            this.form = new Vue.prototype.Form({
                assigned_packages: [],
            });

            console.log(this.availablePackages);

        },

        created () {
            this.eventHub.$on('submit-form', (stay) => {
                this.stayOnPage = stay;
                this.onSubmit();
            })
        },

        beforeDestroy () {
            this.eventHub.$off('submit-form')
        },

        methods: {

            getBadgeVariant(validUntil) {
                if (validUntil === null || validUntil === undefined) {
                    return 'warning';
                }
                const now = new Date();
                const validDate = new Date(validUntil);
                return now < validDate ? 'success' : 'danger';
            },

            getBadgeText(package_) {
                if (package_.pivot.valid_until) {
                    const validUntilDate = new Date(package_.pivot.valid_until);
                    if (new Date() > validUntilDate) {
                        return 'Pakiet wygasł. Przypisany na ' + package_.pivot.interval + ' dni';
                    } else {
                        return 'Pakiet aktywny. Przypisany na ' + package_.pivot.interval + ' dni';
                    }
                } else {
                    return 'Pakiet jeszcze nie aktywowany. Przypisany na ' + package_.pivot.interval + ' dni';
                }
            },

            assign(package_, interval = null) {
                if (interval) {
                    package_.pivot = {
                        interval: interval
                    }
                }
                this.assignedPackages.push(package_);
                this.availablePackages.splice(this.availablePackages.findIndex(item => item.id === package_.id), 1);
                this.edited = true;

                let index = this.selectedNotAssignedPackages.indexOf(package_);
                if (index !== -1) {
                    this.selectedNotAssignedPackages.splice(index, 1);
                }
            },

            assignSelected(interval = null) {
                const packagesToAssign = [...this.selectedNotAssignedPackages];
                packagesToAssign.forEach(package_ => {
                    this.assign(package_, interval);
                });
            },

            extend(package_, interval) {
                const index = this.assignedPackages.indexOf(package_);
                if (index === -1) {
                    return;
                }

                // Cache the reference to the pivot for better readability and performance
                const pivot = this.assignedPackages[index].pivot;

                // Check if 'valid_until' is set
                if (pivot.valid_until) {
                    const validUntilDate = new Date(pivot.valid_until);
                    if (new Date() > validUntilDate) {
                        // If the current date is past 'valid_until', reset it
                        Vue.set(this.assignedPackages[index].pivot, 'interval', interval);
                        Vue.set(this.assignedPackages[index].pivot, 'valid_until', null);
                        Vue.set(this.assignedPackages[index].pivot, 'extended', true);
                    } else {
                        // Otherwise, extend 'valid_until' by 'interval' days and update the interval
                        validUntilDate.setDate(validUntilDate.getDate() + interval);
                        Vue.set(this.assignedPackages[index].pivot, 'interval', pivot.interval + interval);
                        Vue.set(this.assignedPackages[index].pivot, 'valid_until', validUntilDate.toISOString().replace('T', ' ').slice(0, 19));
                        Vue.set(this.assignedPackages[index].pivot, 'extended', true);
                    }
                } else {
                    // If 'valid_until' is not set, simply update the interval
                    Vue.set(this.assignedPackages[index].pivot, 'interval', pivot.interval + interval);
                    Vue.set(this.assignedPackages[index].pivot, 'valid_until', null);
                }

                Vue.set(this.assignedPackages[index], 'is_edited', true);
            },

            remove(package_) {
                this.assignedPackages.splice(this.assignedPackages.findIndex(item => item.id === package_.id), 1);
                delete  package_.pivot;
                this.availablePackages.push(package_);
                this.edited = true;

                let index = this.selectedAssignedPackages.indexOf(package_);
                if (index !== -1) {
                    this.selectedAssignedPackages.splice(index, 1);
                }
            },

            removeSelected() {
                const packagesToRemove = [...this.selectedAssignedPackages];
                packagesToRemove.forEach(package_ => {
                    this.remove(package_);
                });
            },

            onSubmit() {
                this.form.assigned_packages = this.assignedPackages.map(package_ => {
                    return {
                        id: package_.id,
                        interval: package_.pivot ? package_.pivot.interval : null,
                        valid_until: package_.pivot ? package_.pivot.valid_until : null,
                        extended: package_.pivot ? package_.pivot.extended : false
                    }
                });
                this.form.put(route('machine::machines.update-packages', {id: this.machine.id}))
                    .then(response => {
                        if (this.stayOnPage) {
                            this.machine = response.data.machine;
                            this.assignedPackages = response.data.assignedPackages;
                            this.edited = false;
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', response.message, 'success');
                        } else {
                            window.location.href = route('machine::machines.index') + '?status-message=success:' + response.data.message;
                        }
                    })
                    .catch(response => {
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', 'Coś poszło nie tak. Sprawdź poprawność danych.', 'error');
                    });
            },

            checkIfShowAlertBadge(package_) {
                return (package_.is_edited || !package_.hasOwnProperty('pivot') || !package_.pivot.hasOwnProperty('created_at') || this.machine.packages_synchronization_date === null || this.$helpers.stringToDateObject(package_.pivot.created_at).getTime() > this.$helpers.stringToDateObject(this.machine.packages_synchronization_date).getTime()) ||
                    (package_.game_files_last_approved_at !== undefined && package_.game_files_last_approved_at !== null && this.$helpers.stringToDateObject(package_.pivot.created_at).getTime() > this.$helpers.stringToDateObject(this.machine.packages_synchronization_date).getTime()) ||
                    (package_.configuration_last_updated_at !== undefined && this.$helpers.stringToDateObject(package_.configuration_last_updated_at).getTime() > this.$helpers.stringToDateObject(this.machine.packages_synchronization_date).getTime())

            },

            getAlertBadgeText(package_) {
                if (package_.is_edited) {
                    return 'Brak synchronizacji od momentu przedłużenia pakietu.';
                }
                if (!package_.hasOwnProperty('pivot') || !package_.pivot.hasOwnProperty('created_at') || this.machine.packages_synchronization_date === null || this.$helpers.stringToDateObject(package_.pivot.created_at).getTime() > this.$helpers.stringToDateObject(this.machine.packages_synchronization_date).getTime()) {
                    return 'Brak synchronizacji od momentu przypisania pakietu.<br>';
                }
                let text = '';
                if (package_.game_files_last_approved_at !== undefined && package_.game_files_last_approved_at !== null && this.$helpers.stringToDateObject(package_.game_files_last_approved_at).getTime() > this.$helpers.stringToDateObject(this.machine.packages_synchronization_date).getTime()) {
                    text = text + 'Pliki gier zostały zaktualizowane od ostatniej synchronizacji.<br>';
                }
                if (package_.configuration_last_updated_at !== undefined && this.$helpers.stringToDateObject(package_.configuration_last_updated_at).getTime() > this.$helpers.stringToDateObject(this.machine.packages_synchronization_date).getTime()) {
                    text = text + 'Konfiguracja pakietu została zaktualizowana od ostatniej synchronizacji.';
                }
                return text;
            }

        }
    }

</script>

<style scoped>

    .packages-list-heading {
        font-size: 1.25rem;
    }

    .packages-list-wrapper {
        border-top: 1.5px solid #e5e5e5;
    }

    .packages-list-wrapper > .package-element {
        display: flex;
        align-items: center;
        border: 1.5px solid #e5e5e5;
        border-top: none;
    }

    .packages-list-wrapper > .package-element > .custom-control.custom-checkbox {
        display: flex !important;
        align-items: center;
        margin-left: 10px;
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10 and IE 11 */
        user-select: none; /* Standard syntax */
        width: 60%;
    }

    .packages-list-wrapper > .package-element > .custom-control.custom-checkbox > .custom-control-label {
        display: flex;
        align-items: center;
    }

    .packages-list-wrapper > .package-element > .custom-control.custom-checkbox > .custom-control-label::before,
    .packages-list-wrapper > .package-element > .custom-control.custom-checkbox > .custom-control-label::after {
        top: -0.5rem;
    }


    .packages-list-wrapper > .package-element > .custom-control.custom-checkbox > .checkbox-text {
        display: flex;
        align-items: center;
        margin-bottom: 0;
    }

    .packages-list-wrapper > .package-element  .area-icon {
        border-radius: 50%;
        width: 30px;
        margin-left: 10px;
    }

    .packages-list-wrapper > .package-element  .area-icon-placeholder {
        border: 1.5px solid #9b9b9b;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        margin-left: 5px;
        align-items: center;
        text-align: center;
        font-size: 120%;
        color: #9b9b9b;
        font-weight: 600;
        line-height: 28px;
        cursor: default;
    }

    .packages-list-wrapper > .package-element .package-name {
        display: inline-block;
        position: relative;
        padding: 10px;
        left: 0;
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .packages-list-wrapper > .package-element .translation-progress {
        font-size: 0.75rem;
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10 and IE 11 */
        user-select: none; /* Standard syntax */
    }

    .packages-list-wrapper > .package-element  .package-action {
        padding: 10px;
        margin-left: auto;
    }

    .packages-list-empty {
        border: 1.5px solid #e5e5e5;
        padding: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-style: italic;
        text-align: center;
    }

    .badge-pill {
        top: -1px;
        position: relative;
    }

</style>
